const PIXEL_ID = '1154323073507518'

let initialized = false

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Initialize fbq function
  const fbq = function (...args: unknown[]) {
    if ((fbq as any).callMethod) {
      ;(fbq as any).callMethod.apply(fbq, args)
    } else {
      ;(fbq as any).queue.push(args)
    }
  } as any

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = [] as unknown[][]

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize pixel and fire PageView
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackEvent(
  eventName: string,
  params?: Record<string, unknown>,
) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}
